export const ALERT_FORM_BUTTON_CLASS = "alert-form-button";

export const DEFAULT_ALERT_CUSTOM_CLASS = {
	confirmButton: ALERT_FORM_BUTTON_CLASS
};

export const DEFAULT_ALERT_BUTTON_COLOR = "#00518b";